import styled from 'styled-components';
import { getSpace } from '../../../foundation/theme/space.utils';
import { BaseInputRoot } from '../../common/BaseInput/BaseInput.styled';
// styled-components.
// -----------------------------------------------------------------------------
export const TextAreaRoot = styled.textarea `
  ${BaseInputRoot}

  &.error,
  &.success {
    background-position: right ${getSpace('l')} top 12%;
  }
`;
export const TextAreaWrapper = styled.div `
  position: relative;

  ${({ autoGrow }) => autoGrow &&
    `
    & {
      display: grid;
    }
    &::after {
      content: attr(data-replicated-value) " ";
      white-space: pre-wrap;
      visibility: hidden;
    }
    
    & > textarea {
      resize: none;
      overflow: hidden;
    }
    
    & > textarea,
    &::after {
      /* Identical styling required!! */
      ${BaseInputRoot}
    
      grid-area: 1 / 1 / 2 / 2;
    }
  `}
`;
//# sourceMappingURL=TextArea.styled.js.map